export default {
  data() {
    return {
      mailformat: /\S+@\S+\.\S+/,
      englishAlphabets: /[a-z]/g,
    };
  },
  methods: {
    goToPageDetail(url, index, event) {
      const targetNode = event.target;
      const listItemAction = document.getElementsByClassName('list-item-action')[index + 1];
      if (listItemAction && !listItemAction.contains(targetNode)) {
        // when you double click too fast
        // to prevent Avoided redundant navigation to current location
        // ref : https://stackoverflow.com/questions/57837758/navigationduplicated-navigating-to-current-location-search-is-not-allowed
        this.$router.push(url).catch(() => { });
      }
    },
  },
};
